'use client';

import { useEffect } from 'react';
import { ensureRecaptchaEnterpriseLoaded } from './recaptchaEnterprise';

/**
 * Loads reCAPTCHA Enterprise on every authenticated-shell page so Account Defender
 * can collect horizontal telemetry (logged-in vs about-to-log-in traffic).
 */
export function RecaptchaEnterpriseTelemetry() {
  useEffect(() => {
    ensureRecaptchaEnterpriseLoaded();
  }, []);
  return null;
}
